import React from 'react'

import Icon, { IconProps } from './Icon'

/**
 * 左右矢印アイコン
 */
const ArrowIcon: React.FC<IconProps & ArrowIconProps> = (props) => {
  return (
    <Icon {...props}>
      {(props.left || !props.right) && (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="11.999"
          height="20.5"
          viewBox="0 0 11.999 20.5"
        >
          <path d="M9.537,20.083.292,10.946a.975.975,0,0,1,0-1.392L9.537.417a1.456,1.456,0,0,1,2.041,0,1.415,1.415,0,0,1,0,2.016L3.669,10.25l7.909,7.815a1.417,1.417,0,0,1,0,2.017,1.456,1.456,0,0,1-2.041,0" />
        </svg>
      )}
      {props.right && (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="11.999"
          height="20.5"
          viewBox="0 0 11.999 20.5"
        >
          <path
            d="M9.537,20.083.292,10.946a.975.975,0,0,1,0-1.392L9.537.417a1.456,1.456,0,0,1,2.041,0,1.415,1.415,0,0,1,0,2.016L3.669,10.25l7.909,7.815a1.417,1.417,0,0,1,0,2.017,1.456,1.456,0,0,1-2.041,0"
            transform="translate(11.999 20.5) rotate(180)"
          />
        </svg>
      )}
    </Icon>
  )
}

type ArrowIconProps = {
  left?: boolean
  right?: boolean
}

export default ArrowIcon
